<template>
  <el-dialog title="清洗确认返回"
             :visible.sync="dialogVisible"
             top="10px"
             width="50%"
             :close-on-click-modal="false"
             destroy-on-close
             @closed="progressAfterDialogClosed">
    <el-form label-width="80px">
      <el-form-item label="备注">
        <el-input v-model="form.file_remarks"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入备注内容"
                  maxlength="500"
                  show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item label="文件上传">
        <el-upload ref="uploadRef"
                   class="no-transition-upload"
                   action=""
                   :auto-upload="false"
                   :on-change="handleFileChange"
                   drag
                   list-type="text">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text"
               style="font-size: 12px;line-height: 1.2;">
            将文件拖到此处，或<em>点击上传</em><br>
            文件多于20个时建议上传zip压缩文件
          </div>
          <template slot="file"
                    slot-scope="{ file }">
            <div class="upload-file-item">
              <a class="upload-file-link"
                 href="javascript:void(0)"
                 @click.prevent.stop="downloadProgressAttachFile(file)">
                {{ file.name }}</a>
              <i class="el-icon-download"
                 style="margin-right: 6px;cursor: pointer;"
                 @click="downloadProgressAttachFile(file)"></i>
              <i class="el-icon-delete"
                 style="cursor: pointer;"
                 @click="removeFile(file)"></i>
            </div>
          </template>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit">提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import projectMixins from '@views/project/project.mixins'

export default {
  mixins: [userWorkInfoMixin, projectMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      form: {
        cleaned_files: [],
        file_remarks: '',
      },
    }
  },
  created () {},
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user,
    }),
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.initAttr(this.fullNode.project_node || {})
        }
      },
      immediate: true,
    },
  },
  methods: {
    initAttr (projectNode) {
      this.form.cleaned_files = _.get(projectNode, 'node_result.cleaned_files', []).map(item => ({...item}))
      this.form.file_remarks = _.get(projectNode, 'node_result.file_remarks', '')
      this.$nextTick(() => {
        this.$refs.uploadRef.uploadFiles = this.form.cleaned_files.map(f => ({
          name: f.name,
          url: f.url,
          status: 'success',
          uid: f.uid || Date.now() + Math.random()
        }))
      })
    },
    async handleFileChange (file, fileList) {
      try {
        await this.withLoading(async () => {
          const url = await this.doAdminDirectUploadFile(file.raw)
          if (url) {
            file.url = url
            this.form.cleaned_files.push(this.formatStandardFile(file, this.loginUser))
          } else {
            // 上传失败，从 upload 列表中移除
            this.$refs.uploadRef.handleRemove(file)
          }
        }, '文件上传中...')
      } catch (e) {
        this.$message.error('添加至文件列表失败，原因: ' + e)
        this.$refs.uploadRef.handleRemove(file)
      }
    },
    async removeFile (file) {
      try {
        await this.$confirm(`确定要移除文件【${file.name}】吗？`, '移除文件警告')
        this.$refs.uploadRef.handleRemove(file)
        const index = this.form.cleaned_files.findIndex(f => f.name === file.name && f.url === file.url)
        if (index > -1) {
          this.form.cleaned_files.splice(index, 1)
        }
      } catch (e) {
        // 用户取消，不做任何操作
      }
    },
    async onSubmit () {
      const params = {id: this.projectId, ...this.form}
      await this.withLoading(async () => {
        try {
          const res = await request.common('uploadCleanedFilesApi', params)
          this.progressDialogAfterSubmitSuccess(res.data)
          this.$message.success('清洗确认数据保存成功')
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        }
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.upload-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file-link {
  color: #409eff;
  text-decoration: none;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
</style>

<style lang="scss">
.no-transition-upload .el-upload-list__item,
.no-transition-upload .el-list-enter-active,
.no-transition-upload .el-list-leave-active {
  transition: none !important;
}

.no-transition-upload .el-list-enter,
.no-transition-upload .el-list-leave-to {
  opacity: 1 !important;
  transform: none !important;
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/project/components/UploadCleanedFilesDialog.vue